import { ElementType } from 'react';
import { TypographyProps, TypographySize, TypographyVariant } from './interface';

export type CalculatedTypographyProps = {
  component: ElementType<any>;
  fontWeight: number;
  fontSize: string;
  lineHeight: number;
};

type SizeMap = { [K in TypographySize]?: CalculatedTypographyProps };
type TypographyPropsMap = { [K in TypographyVariant]: SizeMap };

export const getCalculatedTypographyProps = (
  variant: TypographyProps['variant'] = 'body',
  size: TypographyProps['size'] = 'm',
  environment: 'web' | 'mobile',
): CalculatedTypographyProps => {
  const isMobile = environment === 'mobile';
  const propsMapping: TypographyPropsMap = {
    label: {
      xs: {
        component: 'p',
        fontWeight: 540,
        fontSize: '11px',
        lineHeight: 16,
      },
      s: {
        component: 'p',
        fontWeight: 620,
        fontSize: '13px',
        lineHeight: 18,
      },
      m: {
        component: 'p',
        fontWeight: 610,
        fontSize: isMobile ? '16px' : '14px',
        lineHeight: isMobile ? 24 : 20,
      },
      l: {
        component: 'p',
        fontWeight: 610,
        fontSize: isMobile ? '18px' : '16px',
        lineHeight: 24,
      },
    },
    body: {
      s: {
        component: 'p',
        fontWeight: 420,
        fontSize: '12px',
        lineHeight: 16,
      },
      m: {
        component: 'p',
        fontWeight: 420,
        fontSize: isMobile ? '16px' : '14px',
        lineHeight: isMobile ? 24 : 20,
      },
      l: {
        component: 'p',
        fontWeight: 420,
        fontSize: isMobile ? '18px' : '16px',
        lineHeight: 24,
      },
    },
    heading: {
      xs: {
        component: 'h4',
        fontWeight: 610,
        fontSize: '18px',
        lineHeight: 24,
      },
      s: {
        component: 'h3',
        fontWeight: 610,
        fontSize: '20px',
        lineHeight: 28,
      },
      m: {
        component: 'h1',
        fontWeight: 610,
        fontSize: '24px',
        lineHeight: 32,
      },
      l: {
        component: 'h1',
        fontWeight: 610,
        fontSize: '28px',
        lineHeight: 40,
      },
    },
  };

  const props = propsMapping[variant][size];
  if (!props) {
    throw new Error('Invalid Typography props');
  }

  return props;
};
